var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderSelected = function SvgOrderSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.373 11.243h2.312a.8.8 0 0 1 .566 1.365l-2.312 2.312a.8.8 0 0 1-1.131 0l-2.311-2.312a.8.8 0 0 1 .565-1.365h2.312Z",
    fill: "currentColor"
  })));
};
export default SvgOrderSelected;